<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar
        title="Q8 Fuel on the Go"
        :has-back-button="true"
        :is-overlay="true"
      />
      <o-map />
      <o-section-header title="Tankstations" />
      <o-section>
        <o-empty-state
          label="We zijn aan het zoeken naar tankstations bij jou in de buurt."
        >
          <template #icon>
            <o-spinner />
          </template>
        </o-empty-state>
      </o-section>
    </o-view>
  </o-view>
</template>

<script>
import OEmptyState from '@/components/OEmptyState.vue'
import OMap from '@/components/OMap.vue'
import OPayButton from '@/components/OPayButton.vue'
export default {
  name: 'CambioOnboardingConfirmation',
  components: {
    OEmptyState,
    OMap,
    OPayButton
  },
  mounted() {
    window.setTimeout(() => {
      this.$router.push('/sales/fuel/q8/stations/results')
    }, 3000)
  }
}
</script>

<style lang="scss"></style>
